import { Injectable, ErrorHandler, LOCALE_ID, Injector, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ActivityTrackerService } from '../activity/activity-tracker.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private locale = inject(LOCALE_ID);
  private injector = inject(Injector);


  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      // HTTP errors are handled by the ErrorInterceptor
      return;
    }

    // Client-side / runtime errors
    const message = error?.message || 'Unknown error';
    const stack = error?.stack || '';

    if (!environment.production) {
      console.error('[Global Error Handler]', {
        message,
        stack,
        locale: this.locale,
        timestamp: new Date().toISOString(),
      });
    }

    // Reported to the server as a short, stack-free activity event (resolved lazily: the tracker
    // depends on services that must not be created while the error handler itself is being built).
    try {
      this.injector.get(ActivityTrackerService).trackError(error);
    } catch {
      /* reporting is best effort */
    }
  }
}
